import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function StarIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="StarIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="FontAwsome_star_"
                d="M39.744,6.49l-5.539-.808L31.729.663a1.214,1.214,0,0,0-2.176,0l-2.476,5.02-5.539.808a1.214,1.214,0,0,0-.671,2.07l4.007,3.905-.948,5.516a1.213,1.213,0,0,0,1.759,1.278l4.955-2.6,4.955,2.6a1.213,1.213,0,0,0,1.759-1.278l-.948-5.516L40.415,8.56a1.214,1.214,0,0,0-.671-2.07Z"
                transform="translate(-19.985 0.513)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
